import React from "react";
import { Glyph3D, Layer3D } from "./glyph-3d.jsx";
import { S } from "../site.js";

const svgFull = { position: "absolute", inset: 0, width: "100%", height: "100%", overflow: "visible" };

function JapaneseQualityGlyph() {
  return (
    <Glyph3D>
      <Layer3D z={26}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="14" y="20" width="60" height="6" rx="2" fill="currentColor" />
        </svg>
      </Layer3D>
      <Layer3D z={14}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="14" y="32" width="44" height="6" rx="2" fill="currentColor" opacity="0.78" />
        </svg>
      </Layer3D>
      <Layer3D z={2}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="14" y="44" width="56" height="6" rx="2" fill="currentColor" opacity="0.62" />
        </svg>
      </Layer3D>
      <Layer3D z={-10}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="14" y="56" width="36" height="6" rx="2" fill="currentColor" opacity="0.45" />
        </svg>
      </Layer3D>
      <Layer3D z={32}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="74" cy="65" r="6" fill="currentColor" />
        </svg>
      </Layer3D>
    </Glyph3D>
  );
}

function MarketGlyph() {
  return (
    <Glyph3D>
      <Layer3D z={-6}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M10 64 H78" stroke="currentColor" strokeWidth="1.5" opacity="0.55" />
        </svg>
      </Layer3D>
      <Layer3D z={6}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M14 64 Q44 28 74 64" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.55" />
        </svg>
      </Layer3D>
      <Layer3D z={22}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M14 64 Q44 8 74 64" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.92" />
        </svg>
      </Layer3D>
      <Layer3D z={34}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="44" cy="64" r="7" fill="currentColor" />
        </svg>
      </Layer3D>
    </Glyph3D>
  );
}

function JourneyGlyph() {
  return (
    <Glyph3D>
      <Layer3D z={-8}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M16 56 V64 M40 56 V64 M64 56 V64" stroke="currentColor" strokeWidth="1.5" opacity="0.4" strokeLinecap="round" />
        </svg>
      </Layer3D>
      <Layer3D z={4}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M22 44 H34 M46 44 H58" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M70 44 L80 44 M76 40 L80 44 L76 48" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Layer3D>
      <Layer3D z={18}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="64" cy="44" r="5" fill="currentColor" opacity="0.5" />
        </svg>
      </Layer3D>
      <Layer3D z={26}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="40" cy="44" r="5" fill="currentColor" opacity="0.78" />
        </svg>
      </Layer3D>
      <Layer3D z={34}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="16" cy="44" r="5" fill="currentColor" />
        </svg>
      </Layer3D>
    </Glyph3D>
  );
}

function AIGlyph() {
  return (
    <Glyph3D>
      <Layer3D z={-4}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M24 24 L34 34 M64 24 L54 34 M24 64 L34 54 M64 64 L54 54" stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
        </svg>
      </Layer3D>
      <Layer3D z={14}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="20" cy="20" r="4" fill="currentColor" opacity="0.7" />
          <circle cx="68" cy="20" r="4" fill="currentColor" opacity="0.7" />
          <circle cx="20" cy="68" r="4" fill="currentColor" opacity="0.7" />
          <circle cx="68" cy="68" r="4" fill="currentColor" opacity="0.7" />
        </svg>
      </Layer3D>
      <Layer3D z={30}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="32" y="32" width="24" height="24" rx="6" fill="currentColor" />
        </svg>
      </Layer3D>
    </Glyph3D>
  );
}

function ProductPracticeGlyph() {
  return (
    <Glyph3D>
      <Layer3D z={-8}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <rect x="14" y="18" width="60" height="52" rx="8" stroke="currentColor" strokeWidth="1.5" opacity="0.38" />
        </svg>
      </Layer3D>
      <Layer3D z={10}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <path d="M24 56 38 42l11 9 16-22" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" opacity="0.72" />
          <circle cx="24" cy="56" r="4" fill="currentColor" opacity="0.52" />
          <circle cx="49" cy="51" r="4" fill="currentColor" opacity="0.72" />
        </svg>
      </Layer3D>
      <Layer3D z={30}>
        <svg viewBox="0 0 88 88" fill="none" style={svgFull}>
          <circle cx="65" cy="29" r="7" fill="currentColor" />
          <path d="M61.5 29h7M65 25.5v7" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.82" />
        </svg>
      </Layer3D>
    </Glyph3D>
  );
}

function StrengthCard({ no, title, body, glyph, accent, tags, span, review = false, initiallyOpen = false }) {
  const accentColor = {
    indigo: "var(--indigo)",
    vermilion: "var(--vermilion)",
    moss: "var(--moss)",
  }[accent];
  return (
    <article
      className="card is-floating strength-card"
      style={{
        gridColumn: `span ${span}`,
        padding: 34,
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gridTemplateRows: "auto 1fr",
        gap: 22,
        minHeight: 286,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="mono" style={{ fontSize: 11, color: "var(--fg-subtle)", letterSpacing: "0.1em", gridColumn: "1 / 2" }}>
        STRENGTH / {no}
      </div>
      <div style={{
        gridColumn: "2 / 3", gridRow: "1 / 3", width: 88, height: 88,
        color: accentColor, opacity: 0.95, perspective: "320px",
      }}>
        {glyph}
      </div>
      <div style={{ gridColumn: "1 / 2", gridRow: "2 / 3" }}>
        <h3 className="strength-card-title" style={{ marginBottom: 12, maxWidth: 360 }}>{title}</h3>
        <p className="strength-card-body" style={{ color: "var(--fg-muted)", fontSize: 15.5, lineHeight: 1.52, maxWidth: 390 }}>{body}</p>
      </div>
      <div aria-hidden="true" style={{
        position: "absolute", right: -60, bottom: -60, width: 200, height: 200,
        borderRadius: "50%",
        background: `radial-gradient(circle, ${accentColor} 0%, transparent 70%)`,
        opacity: 0.08, pointerEvents: "none",
      }} />
    </article>
  );
}

function Strength() {
  const reviewCards = [
    {
      no: "01",
      title: "AI-driven from the inside out",
      body: "We use AI in our own research, proposals, design, and development. What we learn shapes our client work, while people remain responsible for important decisions.",
      glyph: <AIGlyph />,
      accent: "indigo",
    },
    {
      no: "02",
      title: "Strategy stays connected to delivery",
      body: "We connect business understanding, product direction, focused prototypes, delivery, and improvement. The work does not stop at a strategy document.",
      glyph: <JourneyGlyph />,
      accent: "moss",
    },
    {
      no: "03",
      title: "Quality you can see in the process",
      body: "Clear requirements, decision records, UX detail, QA, maintainable systems, and accountable handover make work easier to review and operate.",
      glyph: <JapaneseQualityGlyph />,
      accent: "indigo",
    },
    {
      no: "04",
      title: "Myanmar context with a cross-market view",
      body: "We work with Myanmar, Japanese, and international teams. Local context and clear communication inform each decision.",
      glyph: <MarketGlyph />,
      accent: "vermilion",
    },
    {
      no: "05",
      title: "We learn by building and operating our own products",
      body: "Our products and internal AI experiences give us practical learning. They are not presented as client outcomes or proof of customer adoption.",
      glyph: <ProductPracticeGlyph />,
      accent: "moss",
    },
  ];
  const cards = reviewCards;

  return (
    <section className="section-pad" id="strength" style={{ position: "relative" }}>
      <style>{`
        .strength-h8-actions { display:flex; gap:12px; flex-wrap:wrap; margin-top:28px; }
      `}</style>
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">WHY NEXT</div>
          <h2>
            AI-driven in practice. <span style={{ color: "var(--indigo)" }}>Accountable in delivery.</span>
          </h2>
          <div className="strength-h8-actions">
            <a href={S.howWeStart} className="btn btn-primary btn-arrow"><span>How we work</span></a>
            <a href={S.previews} className="btn btn-secondary btn-arrow"><span>Meet our team</span></a>
          </div>
        </div>

        <div className="grid-strength" style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 20 }}>
          {cards.map((c, i) => (
            <StrengthCard key={c.no} {...c} review={true} initiallyOpen={i === 0} span={[7, 5, 5, 7, 12][i]} />
          ))}
        </div>
      </div>
    </section>
  );
}

export { Strength };
